import React from 'react';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'large', 
  fullScreen = true,
  className = ''
}) => {
  const sizeClasses = {
    small: 'h-6 w-6 border-2',
    medium: 'h-16 w-16 border-4',
    large: 'h-24 w-24 border-4'
  };

  const logoSizes = {
    small: 'h-3 w-3',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  const spinnerElement = (
    <div className="relative flex items-center justify-center">
      <div className={`animate-spin rounded-full border-blue-200 border-t-blue-600 ${sizeClasses[size]}`}></div>
      <img
        src="/HO-Logo.png"
        alt="HotelOnline Logo"
        className={`absolute object-contain ${logoSizes[size]}`}
        style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)', position: 'absolute' }}
      />
    </div>
  );

  if (fullScreen) {
    return (
      <div className={`flex items-center justify-center min-h-screen bg-white ${className}`}>
        {spinnerElement}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      {spinnerElement}
    </div>
  );
};

export default Spinner; 